import { Form, Row, Col, Input, Button, FormInstance, message, DatePicker, Select, InputNumber } from 'antd';
import moment from 'moment';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { getApi, patchApi } from '../../../../shared/src/apis';
import { getDataInfo, stepperMoving } from '../../stores/actions';
import { request } from '../../../../shared/src/apis';
import helper from '../../utils/helper';
import { UserInfoUI, MaxInstallmentsWarningModal } from '@operations/shared';
import { MeezaCardStatus } from '../../utils/commonInterfaces';
import { getCompanyBranchesByCompanyIdApi } from '../../utils/apisConsts';
import { getRegion } from '../../components/regionWrapper';
import { Region } from '../../utils/commonInterfaces';

const { Option } = Select
interface Props {
    getApi?: any,
    info?: {
        userID: any;
        firstName: any;
        middleName: any;
        lastName: any;
        bankName: any;
        bankAccountHolderName: any;
        bankAccountNumber: any;
        netSalary: any;
        name: string,
        companyName: string,
        phone: string,
        email: string,
        city?: string,

        nationalId: any,
        accountCreatedAt: string,


        userStatus: string,
        userStatusType: string,

        maxAdvancePercentAllowedPerCompany: number,
        maxBalance: number,
        maxShoppingBalnce: number,

        wallet: number,
        staff_id: string,
        companyMaxInstallmentCount: number,
        nationalIDNumber: string,
        hiringDate: string,
        jobTitle: string,
        companyID: number,
        department: any
        hasMeezaCard: string | number,
        companyBranchID?: number | null,
        probationPeriod?: number,
        userMaxInstallments?: number | string | null,


    }
    patchApi?: any,
    stepperMoving?: any,
    getDataInfo: (info: {}) => void,
    fromViewUserAction: boolean,
    request: any,
}
class EditApprovedUsers extends Component<Props> {
    state = {
        loadData: false,
        departments: [],
        loadingDepartments: false,
        loadingBranches: false,
        companyBranches: [],
        warningModalVisible: false,
        pendingValues: null as any,
    }
    formRef = React.createRef<FormInstance>();
    region = getRegion();

    componentDidMount() {
        this.getCompanyDepartments()
        if (this.region === Region.EG) {
            this.getCompanyBranches()
        }
    }

    updateUser = (values: any) => {
        const enteredMaxInstallments = values?.userMaxInstallments;
        const companyMax = this.props.info?.companyMaxInstallmentCount;
        const currentMaxInstallments = this.props.info?.userMaxInstallments;
        const hasEnteredMaxInstallments = enteredMaxInstallments !== undefined && enteredMaxInstallments !== null && enteredMaxInstallments !== '';
        const hasChangedMaxInstallments = hasEnteredMaxInstallments && Number(enteredMaxInstallments) !== Number(currentMaxInstallments);

        // Warn only when max installments was changed and exceeds the company's maximum
        if (hasChangedMaxInstallments && companyMax && Number(enteredMaxInstallments) > Number(companyMax)) {
            this.setState({ warningModalVisible: true, pendingValues: values });
            return;
        }

        this.proceedUpdate(values);
    };

    handleWarningCancel = () => this.setState({ warningModalVisible: false, pendingValues: null });

    handleWarningConfirm = () => {
        const pendingValues = this.state.pendingValues;
        this.setState({ warningModalVisible: false, pendingValues: null });
        if (pendingValues) this.proceedUpdate(pendingValues);
    };

    proceedUpdate = async (values: any) => {
        console.log("🚀 ~ file: userInfoForm.tsx ~ line 87 ~ EditUserInfo ~ updateUser= ~ values", values)
        this.setState({ loadData: true });
        const data: any = {
            userID: this.props.info?.userID,
            userInfo: {
                firstName: values?.firstName,
                middleName: values?.middleName,
                lastName: values?.lastName,
                email: values?.email,
                nationalIdNumber: values?.nationalId ? values?.nationalId : null,
                phone: values?.phone,
                staff_id: values?.staff_id,
                hiringDate: values?.hiringDate ? moment(values?.hiringDate).format("YYYY/MM/DD 12:00:00") : '',
                jobTitle: values?.jobTitle,
                departmentID: values?.departmentID,
                companyBranchId: this.region === Region.EG && values?.companyBranchID  ? values?.companyBranchID : null,
                hasMeezaCard: values?.hasMeezaCard === MeezaCardStatus.recievied ? true : false,
                probationPeriod: this.region === Region.SE && values?.probationPeriod ? values?.probationPeriod : null,
                city: this.region === Region.SE && values?.city ? values?.city : null,
                userMaxInstallments: (values?.userMaxInstallments !== undefined && values?.userMaxInstallments !== null && values?.userMaxInstallments !== '')
                    ? Number(values.userMaxInstallments)
                    : null,
            }

        };

        const updateUser = await this.props.patchApi("/users/updateApprovedUserInfo", data);
        const res = await updateUser.payload;
        try {
            if (res.status === 200) {
                this.setState({ loadData: false });
                message.success(res.message, 4);
                if (this.props?.fromViewUserAction) {
                    const department = this.state.departments?.find((department: any) => department?.id === data?.userInfo?.departmentID)
                    const companyBranch = this.region === Region.EG ? this.state.companyBranches?.find((branch: any) => branch?.id === data?.userInfo?.companyBranchID) : null;
                    this.props.getDataInfo({
                        ...this.props.info,
                        ...data?.userInfo,
                        department,
                        nationalIDNumber: "nationalId" in values ? values.nationalId : this.props.info?.nationalIDNumber,
                        email: "email" in values ? values.email : this.props.info?.email,
                        phone: "phone" in values ? values.phone : this.props.info?.phone,
                        hasMeezaCard: "hasMeezaCard" in values ? Number(values.hasMeezaCard) : this.props.info?.hasMeezaCard,
                        companyBranch: companyBranch ? companyBranch : null
                    });
                    this.props.stepperMoving(1);
                } else {
                    helper.resetAccountTableInStepper();
                    this.props.stepperMoving(0);
                }
            } else {
                this.setState({ loadData: false });
                message.error(res.message, 4);
            }
        } catch (error) {
            this.setState({ loadData: false });
            message.error("Something went wrong, please try again", 4);
        }

    };

    getCompanyDepartments = async () => {
        try {
            this.setState({ loadingDepartments: true })
            const departs: any = await helper.getDepartments({ companyID: this.props.info?.companyID })
            if (departs.data.status === 200) {
                this.setState({ loadingDepartments: false, departments: departs.data.departments })
            }
            else {
                this.setState({ loadingDepartments: false, errorMode: true })
            }
        }
        catch (error) {
            console.log("🚀 ~ file: userInfoForm.tsx:233 ~ EditUserInfo ~ getCompanyDepartments= ~ error:", error)
            this.setState({ loadingDepartments: false, errorMode: true })
        }
    }

    getCompanyBranches = async () => {
        try {
            this.setState({ loadingBranches: true })
            const branches: any = await this.props.request({ url: getCompanyBranchesByCompanyIdApi + this.props.info?.companyID, method: "GET" })
            if (branches?.data?.status === 200) {
                this.setState({ loadingBranches: false, companyBranches: branches?.data?.data })
            } else {
                this.setState({ loadingBranches: false, errorMode: true })
            }
        }
        catch (error) {
            this.setState({ loadingBranches: false, errorMode: true })
        }
    }   

    render() {
        const { loadData, loadingDepartments, departments } = this.state;
        const loadingBranches = this.region === Region.EG ? this.state.loadingBranches : false;
        const companyBranches = this.region === Region.EG ? this.state.companyBranches : [];
        
        const { info } = this.props;
        const validation: any = helper.regexValidation;
        const basicInfo = [
            {
                key: 'Name',
                value: <Row>
                    <Col span="8">
                        <label>First Name </label>

                        <Form.Item
                            name="firstName"
                            rules={[
                                { required: true, message: "First name is mandatory!" },
                            ]}
                            initialValue={info?.firstName}>
                            <Input placeholder="Enter the first name" style={{ width: '90%' }} />
                        </Form.Item>
                    </Col>
                    <Col span="8">
                        <label>Middle Name </label>
                        <Form.Item
                            name={"middleName"}
                            rules={[
                                {
                                    required: true,
                                    message: "Group name is mandatory",
                                },
                            ]}
                            initialValue={info?.middleName}
                        >
                            <Input placeholder="Enter the middle name" style={{ width: '90%' }} />
                        </Form.Item>
                    </Col>
                    <Col span="8">
                        <label>Last Name </label>

                        <Form.Item
                            name="lastName"
                            rules={[
                                ...(this.region === Region.EG ? [{
                                    required: true,
                                    message: "lastName is mandatory!",
                                }] : []),
                            ]}
                            initialValue={info?.lastName}
                        >
                            <Input placeholder="Enter the last name" style={{ width: '90%' }} />
                        </Form.Item>
                    </Col>
                </Row>
            },
            {
                key: 'Company',
                value: <Form.Item
                    name={'s'}
                    initialValue={info?.companyName ? info?.companyName : 'NA'}
                >
                    <Input readOnly style={{ width: '90%' }} />
                </Form.Item>
            },
            ...(companyBranches?.length > 0 && this.region === Region.EG ?
                [{
                    key: 'Branch',
                    value: (
                        <Form.Item
                            name="companyBranchID"
                            initialValue={info?.companyBranchID ? info?.companyBranchID : null}
                        >
                            <Select style={{ width: '90%' }}
                                loading={loadingBranches}
                                placeholder="Select a branch name">
                                {[{ id: null, name: 'Not sure', nameAr: 'غير متأكد' }, ...companyBranches]?.map((branch: any, key: number) => {
                                    return <Option value={branch?.id} key={key}>{branch?.name}</Option>
                                })}
                            </Select>
                        </Form.Item>
                    )
                }] : []),
            ...(this.region === Region.SE ? [{
                    key: 'City',
                    value: <Form.Item
                        name="city"
                        initialValue={info?.city}
                        rules={[
                            {
                                pattern: helper.regexValidation.englishStringRegex,
                                message: "City field is not valid",
                            }
                        ]}
                    >
                        <Input placeholder="Enter the City Name" style={{ width: '90%' }}/>
                    </Form.Item>
            }] : []),
            {
                key: 'Staff ID',
                value: <Form.Item
                    name="staff_id"
                    rules={[
                        { required: true, message: "Staff Id is mandatory!" },
                    ]}
                    initialValue={info?.staff_id}
                >
                    <Input placeholder="Enter the Staff Id" style={{ width: '90%' }} />
                </Form.Item>
            },
            {
                key: 'Job Title',
                value: <Form.Item
                    name="jobTitle"
                    initialValue={info?.jobTitle}
                >
                    <Input placeholder="Enter the job title" style={{ width: '90%' }} />
                </Form.Item>
            },
            {
                key: 'Department',
                value: <Form.Item
                    name="departmentID"
                    initialValue={this.props.info?.department?.id}
                >
                    <Select style={{ width: '90%' }}
                        loading={loadingDepartments}
                        placeholder="Select a department name">
                        {Array.isArray(departments) && departments.map((department: any, key: number) => {
                            return <Option value={department.id} key={key}>{department.nameEn}</Option>
                        })}
                    </Select>
                </Form.Item>
            },
            {
                key: 'Hiring Date',
                value: <Form.Item
                    name="hiringDate"
                    initialValue={info?.hiringDate ? moment(info?.hiringDate) : undefined}>
                    <DatePicker placeholder="Enter the hiring date" style={{ width: '90%' }} />
                </Form.Item>
            },
            ...(this.region === Region.SE ? [{
                    key: 'Probation Period',
                    value: <Form.Item
                        name="probationPeriod"
                        initialValue={info?.probationPeriod}>
                        <Input placeholder="Enter the probation period" />
                    </Form.Item>
                }] : []),
            {
                key: 'Maximum Installments',
                value: <Form.Item
                    name="userMaxInstallments"
                    initialValue={info?.userMaxInstallments ? Number(info?.userMaxInstallments) : undefined}
                    extra={info?.companyMaxInstallmentCount
                        ? <span style={{ color: '#34a97b', fontWeight: 600, fontSize: 12 }}>Company max: {info?.companyMaxInstallmentCount}</span>
                        : undefined}
                    rules={[{ type: 'integer', min: 1, max: 15, message: 'Maximum Installments must be between 1 and 15' }]}
                >
                    <InputNumber style={{ width: '90%' }} precision={0} placeholder="Leave empty to use company default" />
                </Form.Item>
            },
        ]
        const personalInfo = [
            {
                key: 'Phone',
                value: <Form.Item
                    name={'phone'}
                    rules={[
                        { required: true, message: "Phone is mandatory" },
                    ]}
                    initialValue={info?.phone ? info?.phone : 'NA'}
                >
                    <Input placeholder='Enter your phone ' style={{ width: '90%' }} />
                </Form.Item>
            },
            {
                key: 'Email',
                value: <Form.Item
                    name="email"
                    rules={[
                        {
                            pattern: validation.email,
                            message: "Email is not valid",
                        },
                    ]}
                    initialValue={info?.email}
                >
                    <Input placeholder="Enter the email" style={{ width: '90%' }} />
                </Form.Item>
            },
            {
                key: 'National ID',
                value: <Form.Item
                    name="nationalId"
                    /** info?.nationalIDNumber.includes('null') ? 'NA' : info?.nationalIDNumber */
                    initialValue={info?.nationalIDNumber && info?.nationalIDNumber.includes('null') ? '' : info?.nationalIDNumber}
                >
                    <Input placeholder="Enter the National Id" style={{ width: '90%' }} />
                </Form.Item>
            }
        ]
        const bankInfo = [
            {
                key: 'Meeza Card Status',
                value: <Form.Item
                    name="hasMeezaCard"
                    // rules={[{ required: true, message: 'Required' }]}
                    initialValue={info?.hasMeezaCard}
                >
                    <Select placeholder="Select a status">
                        <Option value={1} disabled>Requested</Option>
                        <Option value={0}>Not Received</Option>
                        <Option value={2}>Received</Option>
                    </Select>
                </Form.Item>
            },
        ]
        return (
            <>
                <Form
                    name="nest-messages"
                    ref={this.formRef}
                    onFinish={this.updateUser}
                >
                    {info && (
                        <Row>
                            <Col span={24}>
                                <UserInfoUI userData={basicInfo} activeKey={1} header={'Basic Information'} nonEditable={true} />
                            </Col>
                            <Col span={24}>
                                <UserInfoUI userData={personalInfo} activeKey={2} header={'Personal Information'} nonEditable={true} />
                            </Col>
                            {this.region === Region.EG && <Col span={24}>
                                <UserInfoUI userData={bankInfo} activeKey={3} header={'Bank Information'} nonEditable={true} />
                            </Col>}

                            <Col style={{ display: "flex", justifyContent: "flex-end" }} span={24}>
                                <Form.Item>
                                    <Button style={{ margin: '30px 0 0 0 ', backgroundColor: "#7CC58F", borderColor: "#7CC58F" }} className='changeUserStatusBtn' shape="round" type="primary" htmlType="submit" loading={loadData} >
                                        Update
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    )}
                </Form>

                <MaxInstallmentsWarningModal
                    open={this.state.warningModalVisible}
                    companyMax={info?.companyMaxInstallmentCount}
                    onConfirm={this.handleWarningConfirm}
                    onCancel={this.handleWarningCancel}
                />
            </>
        )
    }
}
const mapStateToProps = (state: any) => ({
    info: state.actionsReducer.info,
    fromViewUserAction: state.actionsReducer.isViewUserAction,
    request: state.actionsReducer.request,
})
export default connect(mapStateToProps, { getApi, patchApi, stepperMoving, getDataInfo, request })(EditApprovedUsers)
